import { formatUIDate } from 'utils/helpers'
import { WasteCategoryReportPayloadItem, WasteCategoryReportTableItem } from '../interfaces'

export const toTableRowItems = (
  items: WasteCategoryReportPayloadItem[]
): WasteCategoryReportTableItem[] =>
  items.map(item => ({
    id: item.id,
    wanNumber: item.wanNumber ?? '',
    storeName: item.storeName ?? '',
    legalEntity: item.legalEntity ?? '',
    creationDate: formatUIDate(item.date),
    wasteCategories: item.wasteCategories
      ? item.wasteCategories.map((category: string) => ({ name: category }))
      : [],
    companyName: item.companyName ?? '',
    measuredWeight: item.measuredWeight ?? '',
    wasteReports: item.wasteReports
      ? item.wasteReports.map((report: string) => ({ name: report }))
      : [],
    documents: item.documents ?? []
  }))
